import React, { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import Checkmark from "components/Creation/components/checkmark";
import { BsPen, BsPencil, BsXLg } from "react-icons/bs";
const Bubble = ({
  cellNo,
  children,
  style,
  onClick,
  isSelected,
  shouldAnimate,
  showAsPink,
  animationInDelay,
  onClickedCancel,
  bgImg,
  canClickCancel,
  onClickedEdit,
  className,
}) => {
  let useSelectedStyle = isSelected || cellNo === 9;
  bgImg =
    bgImg ||
    (cellNo === 9
      ? 'url("/images/bubble-bgs/m-orange.jpg")'
      : 'url("/images/bubble-bgs/peachy.jpg")');
  style = {
    backgroundImage: useSelectedStyle || showAsPink ? bgImg : "none",
    backgroundColor: useSelectedStyle || showAsPink ? "transparent" : "white",
    backgroundPosition: "center",
    backgroundSize: "102%",
    backgroundRepeat: "no-repeat",
    border: "1px solid #e2e8f0",
    borderColor: useSelectedStyle ? "transparent" : "#e2e8f0",
    boxShadow: "0 0 20px 10px rgba(0,0,0,0.1)",
    color: useSelectedStyle || showAsPink ? "white" : "black",
    textShadow: useSelectedStyle || showAsPink ? "0px 0px 9px #ce5151" : "none",
    ...style,
  };
  return (
    <Animated
      animationIn={shouldAnimate ? "bounceIn" : "none"}
      className="w-full h-full"
      animationInDelay={
        animationInDelay ? animationInDelay : cellNo === 9 ? 0 : cellNo * 50
      }
    >
      <div
        className={`w-full h-full rounded-full md:relative cursor-pointer scale-[90%] hover:scale-[100%] transition-all duration-300  ${
          cellNo === 9 || !children ? "pointer-events-none" : "z-10"
        } ${className ? className : ""}`}
        style={style}
        onClick={onClick}
      >
        <div className="">
          {/* <h1>
            ({cellNo})
          </h1> */}
          <div
            className={`${
              cellNo === 9 ? "text-3xl" : ""
            }  font-bold lowercase flex items-center justify-center text-center absolute w-full h-full top-0 left-0`}
            style={{
              letterSpacing: "0.5px",
            }}
          >
            {children}
          </div>
        </div>
        {isSelected && (
          <div
            className="absolute top-[10%] right-[0%]"
            style={{ fontSize: "2.5em" }}
          >
            <Checkmark />
          </div>
        )}
        {(isSelected || canClickCancel) && onClickedCancel && (
          <div className="z-10 opacity-0 hover:opacity-100 absolute left-0 flex items-center justify-center w-full h-full">
            <div
              className="absolute bottom-0 left-0 bg-white rounded-full p-4 border-sm shadow-md"
              onClick={(e) => {
                e.stopPropagation();
                onClickedCancel();
              }}
            >
              <BsXLg style={{ fontSize: "14px", color: "black" }} />
            </div>
          </div>
        )}

        {onClickedEdit && (
          <div className="z-10 opacity-100 md:opacity-0 hover:opacity-100 absolute left-0 flex items-center justify-center w-full h-full">
            <div
              className="absolute bottom-0 left-0 bg-white rounded-full p-4 border-sm shadow-md"
              onClick={(e) => {
                e.stopPropagation();
                onClickedEdit();
              }}
            >
              <BsPencil style={{ fontSize: "14px", color: "black" }} />
            </div>
          </div>
        )}
      </div>
    </Animated>
  );
};

export default Bubble;
